 
 

import { useState, useEffect, useRef } from "react"; 
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import MKTypography from "components/MKTypography"; 
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Dropdowns from "components/AppKey/Dropdowns";
import MKBadge from "components/MKBadge";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { appAuth } from "../../contexts/AppContext"
import { useAuth } from "../../contexts/AuthContext"
import AppActionQRDetail from "./AppActionQRDetail";

export default function AppActionQR({app, action}) { 

    const [qrData, setQRData] = useState({name:"", actionId: action ? action.actionId : "", appId: action ? action.appId : ""});
    const {getActionQR, createActionQR, updateActionQR, deleteActionQR, copyActionQR} = appAuth()
    

    const [message, setMessage] = useState("")
    const [error, setErrorMessage] = useState("")

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [total, setTotal] = useState();
    const [filter, setFilter] = useState({appId:app.appId, type:"all",  limit:25, offset: 0})
    const [search, setSearch] = useState("") 

    const [actionQRData, setActionQRData] = useState([]); 
    const [modalState, setModalState] = useState({
        showCreateQR:false,
        showEditQR:false,
        showDeleteQR:false,
        action:{}, 
        qr:{}
    });

    const actionQRTableHeader = [
        { id: "qrId", name: "QR Id", align: "center" }, 
        { id: "name",  name: "QR name", align: "center" },  
        { id: "device", name: "Device", align: "center" },
        { id: "lastScanned", name: "Scanned", align: "center" }, 
        { id: "created", name: "created", align: "center" }, 
        { id: "control", name: "control", align: "center" },
    ]

    const renderRef = useRef(false)

    useEffect(() => {
     

        console.log("AppAction useEffect appId ", action.appId);
        if (renderRef.current === false){

            fetchActionQR()

            return () => {
                renderRef.current = true
                console.log("render clean up. ")
            }
        }

    }, [])

    const saveActionQRDetail = async (data) => {
        
        console.log("saveActionQRDetail ", data)
        setErrorMessage("")
        setMessage("")

        let result = await updateActionQR(data)
        if (result.error) {
            setErrorMessage(result.error.message) 
            return;
        } 
        toggleEditQRModal()
        fetchActionQR()
        
    }

    const fetchActionQR = async() => {
     
        setActionQRData(prevItems => { 
            return [];
        });  
       
        let result = await getActionQR(action.actionId) 
      
        if(!result) return;
        
        for (let index = 0; index < result.length; index++) {
            
            let element = makeRecord(result[index]); 
            element.number = index + 1 
          
            setActionQRData(prevItems => { 
                return [...prevItems, element];
            });  
           
        } 
    }


    
    const formatDate = (dateString) => {
        const options = { year: "2-digit", month: "2-digit", day: "2-digit", hour: 'numeric', hour12: true}
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const makeRecord = (item) => { 
    
        item.created = formatDate(item.createdAt)
        item.updated = formatDate(item.updatedAt) 
        item.scanned = formatDate(item.lastScanned)
        return item
          
    }

    const handleChangeRowsPerPage = (value) => {

        console.log("handleChangeRowsPerPage newPage ", value);
        setFilter({
            ...filter,
            ["limit"]: value,
            ["offset"] : 1
        });

        //setTotalPage( Math.ceil(total/value)) 

        setRowsPerPage(value);
        setPage(1); 
        
    };


    const onChangeInput = (evt) => { 

        setQRData({
            ...qrData,
            [evt.target.name]: evt.target.value,
        });
    }

    

    const handleCreateQR = async (data) => {
        setErrorMessage("")
        setMessage("") 
        
        let result = await createActionQR(qrData)
        
        if (result.error) {
            setErrorMessage(result.error.message) 
            return;
        } 
        
        let element = makeRecord(result); 
        element.number = actionQRData.length + 1 
      
        setActionQRData(prevItems => { 
            return [element, ...prevItems];
        });  
        
        setMessage("QR created successfully") 
        //fetchActionQR()
        toggleCreateQRModal()

        setQRData({
            ...qrData,
            ['name']: ""
        });

    }

    
    const toggleCreateQRModal = () => { 
        setModalState({ ...modalState, ["showCreateQR"]:!modalState.showCreateQR })   
    }

    const toggleCopyQRModal = async (item) => {
        
        if(window.confirm(`Duplicate QR Code: ${item.name}. Are you sure to duplicate this qr?`)) {
            let result = await copyActionQR(item)
            if(result) fetchActionQR() 
        }

    }
    
    const toggleEditQRModal = (item) => {
        setModalState({ ...modalState, ["showEditQR"]:!modalState.showEditQR, qr:item })   
    }

    const toggleDeleteQRModal = async (item) => {

        if(window.confirm(`Delete QR Code: ${item.name}. Are you sure to delete?`)) {
            let result = await deleteActionQR(item)
            if(result) fetchActionQR() 
        }

        //setModalState({ ...modalState, ["showDeleteQR"]:!modalState.showDeleteQR, qr:item })   
    }

    const onKeyEnterDown = (event) => {
        if(event.keyCode == 13) {
            handleCreateQR()
        }
    }


    
    const getRandomKey = (index) => {
        return  `${index}${Date.now()}`
    }

    

    return(
        <MKBox>
            <MKBox display="flex" justifyContent="space-between"> 
                    
                <MKBox alignItems="center" justifyContent="left" display="flex">

                    <MKTypography variant="body2" color="text">  Show:  </MKTypography> 
                    <Dropdowns items={[25,  100, 150]} defaultValue = {rowsPerPage}  onChange={handleChangeRowsPerPage}   /> 
                    <MKTypography variant="body2" color="text"> entries  </MKTypography> 

                    <MKBox px={3}> 
                        <MKTypography variant="body2" color="text"> Total Record: {total}  </MKTypography>
                    </MKBox>
                </MKBox>

                
                <Tooltip title="Add QR" placement="top">
                    <MKButton variant="outlined" color="info" onClick={toggleCreateQRModal} px={2} iconOnly> <Icon sx={{ mr: 1 }}>qr_code_2</Icon> </MKButton>
                </Tooltip>
            </MKBox>

 
            {actionQRData.length > 0 ? <TableContainer sx={{ maxHeight: 650 }}>
            <Table responsive="sm">
                <thead>
                <TableRow key={getRandomKey("actionQR")}>
                {actionQRTableHeader.map((column) => (
                    <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="colunmHeader"
                    >
                    {column.name}
                    </TableCell>
                ))}
                </TableRow>
                </thead>
            <TableBody>
                {actionQRData
                    //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item) => {
                        return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={item._id}>
                            {actionQRTableHeader.map((column) => {

                                let value = item[column.id];

                                if (column.id === "status") { 

                                    return (
                                        <TableCell key={column.id} align={column.align} className="tableCell">
                                            { value === "active" ?  <MKBadge variant="contained" badgeContent= {value} color="success" size="xs" container /> :
                                                                    <MKBadge variant="contained" badgeContent= {value} color="error" size="xs" container />
                                            }

                                        </TableCell>
                                    );
                                }

                                else if (column.id === "control") {
                                    return (
                                        <TableCell key={column.id} align={column.align} className="tableCell">
                                            <MKBox>
                                                
                                                <MKButton variant="text" color="info" onClick={ () => toggleEditQRModal(item)} iconOnly px={2} ><Icon>edit</Icon></MKButton> &nbsp;
                                                <MKButton  variant="text" color="error" onClick={ () => toggleDeleteQRModal(item)} iconOnly px={2}><Icon>delete</Icon></MKButton> &nbsp;
                                                <MKButton variant="text" color="info" onClick={ () => toggleCopyQRModal(item)} iconOnly px={2} ><Icon>copy_content</Icon></MKButton> &nbsp;
                                            </MKBox>   
                                        </TableCell>
                                    );
                                }
                                else { 


                                    return (
                                        <TableCell key={column.id} align={column.align} className="tableCell">
                                        {column.format && typeof value === 'number'
                                            ? column.format(value)
                                            : value}
                                        </TableCell>
                                    );
                                }
                            })}
                        </TableRow>
                        );
                    })}
            </TableBody>


            </Table>
            </TableContainer>


            :
                <MKTypography color="info" pr={4}>No Record</MKTypography>
            }

            {Math.ceil(total/rowsPerPage) > 1 &&  
                <Grid container item xs={12} lg={5} justifyContent="center" mx="auto" py={3}> 
                    <Pagination count={Math.ceil(total/rowsPerPage)} showFirstButton showLastButton page={page} onChange={handleChangePage} />
                </Grid>
            }




            <Modal open={modalState.showCreateQR} onClose={() => toggleCreateQRModal()} sx={{ display: "grid", placeItems: "center" }}>
                    <Slide direction="down" in={modalState.showCreateQR} timeout={300}>
                    <Grid container item xs={12} lg={5} justifyContent="center" mx="auto">
                    <Card>
                        <MKBox
                        variant="contained"
                        bgColor="primary"
                        borderRadius="lg"
                        coloredShadow="info"
                        mx={2}
                        mt={-3}
                        p={2}
                        mb={1}
                        textAlign="center" 
                        >
                            <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                                Create QR
                            </MKTypography>
                        
                        </MKBox>
                
                        <MKBox pb={3} px={3}>
                            <MKBox display="flex" alignitems="center" justifyContent="space-between" p={2}>
                                <MKTypography variant="h5">Create QR for application action '{action.name}'</MKTypography> 
                                
                            </MKBox>
                            <MKBox display="flex" alignitems="center" justifyContent="space-between" px={2}>
                                <MKTypography variant="body2" color="text">Enter your QR Name</MKTypography>
                            </MKBox>
                            
                            <MKBox>
                                    
                                    {error && <MKTypography variant="button" color="error" px={2}>{error}</MKTypography> }
                                    {message && <MKTypography variant="body2" color="info" px={2}>{message}</MKTypography>}
                                    <Divider sx={{ my: 0 }} />
                                
                                    <MKBox p={2}>
                                        
                                        <MKBox >
                                            <MKInput label="Name" inputProps={{ maxLength: 50 }} fullWidth name="name" required value = {qrData.name}  onChange={onChangeInput} onKeyDown = {onKeyEnterDown} />
                                        </MKBox>
                                    </MKBox>
                                    
                                    <Divider sx={{ my: 0 }} />
                                    
                                    <MKBox display="flex" justifyContent="space-between" p={1.5}>

                                        <MKButton variant="gradient" color="dark" onClick={() => toggleCreateQRModal()} >
                                            Close
                                        </MKButton>

                                        <MKButton variant="gradient" color="primary" onClick={() => handleCreateQR()}  >
                                            Submit
                                        </MKButton>

                                    </MKBox>
                                    
                                    
                                
                                </MKBox>
                        </MKBox>
                        
                        </Card>
                    </Grid>
                </Slide>
            </Modal>

            <Modal open={modalState.showEditQR}    sx={{ display: "grid", placeItems: "center" }}>
                <Slide direction="down" in={modalState.showEditQR} timeout={300}>
                    <Grid container item xs={12} lg={12} justifyContent="center" mx="auto">
                    <Card> 
                        <AppActionQRDetail qr={modalState.qr} action={action} onClose={toggleEditQRModal} onSubmit={saveActionQRDetail} /> 
                    </Card>
                    </Grid>
                </Slide>
            </Modal>

        </MKBox>
    )
}